import React from "react";
import PropTypes from "prop-types";
import { clearProviderProducts } from "../../actions/marketplaceActions";
import { useSelector, useDispatch } from 'react-redux';

const LanguageSelector = ({ languages, selectedLanguage, onSelection }) => {

  const dispatch = useDispatch()

  const handleLanguageChange = (e) => {
    onSelection(e.target.value);
    e.target.blur(); // Fixes persistent targeting by Safari/iOS 10.1

    dispatch(clearProviderProducts());
    
  };

  if (languages.length < 2) {
    return null;
  }

  return (
    <p className="apl-header__language">
      <span className="cxa-c-form__select-box">
        <select
          name="languages"
          value={selectedLanguage && selectedLanguage.id}
          id="languages"
          onChange={handleLanguageChange}
        >
          {languages.map((item, index) => (
            <option key={index} value={item.id}>
              {item.name}
            </option>
          ))}
        </select>
      </span>
    </p>
  );
};

LanguageSelector.propTypes = {
  languages: PropTypes.array,
  selectedLanguage: PropTypes.object,
  onSelection: PropTypes.func,
};

export default LanguageSelector;



// WEBPACK FOOTER //
// ./components/common/LanguageSelector.js